import {store} from "src/store";
import Tools from "src/core/Tools";

/**
 * Evita doble envío en formularios y sincroniza el preloader global.
 */
export const requestGuardMixin = {
    data() {
        return {
            procesando: false,
        };
    },
    beforeUnmount() {
        if (this.procesando) {
            this.finalizarProceso();
        }
    },
    methods: {
        iniciarProceso() {
            if (this.procesando) {
                return false;
            }
            this.procesando = true;
            store.dispatch('coreShowLoading');
            return true;
        },
        finalizarProceso() {
            this.procesando = false;
            if (store.getters.coreIsLoading) {
                store.dispatch('coreHideLoading');
            }
        },
        tieneParamsRuta() {
            return Tools.tieneParamsBusquedaRuta(this.$route.params);
        },
    },
};
